<template>
  <v-container>
    <v-card-title>Bienvenue sur la page d'accueil</v-card-title>
    <v-card-text>
      <v-expansion-panels
          v-model="panel"
          multiple
        >
        <v-expansion-panel v-for="(note) in jsonData" :key="note.date" class="mt-3">
            <v-expansion-panel-header class="text-h5 grey lighten-2">
            Release Notes - Version du {{ formatDate(note.date) }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-list class="transparent">
                    <v-list-item v-for="(change) in note.changes" :key="change">
                        <v-list-item-icon>
                            <v-icon>mdi-check-circle-outline</v-icon>
                        </v-list-item-icon>
                    {{ change }}
                    </v-list-item>
                </v-list>
            </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import { formatDate } from '@/utils/dates'

export default Vue.extend({
  name: 'ReleaseNotes',
  data: () => ({
    jsonData: '',
    panel: [0],
  }),
  methods: {
    formatDate,
    getReleaseNotes() {
      fetch('release-notes.json')
        .then(response => response.json())
        .then(data => {
          this.jsonData = data
          return data
        })
    },
  },
  mounted() {
    this.getReleaseNotes()
  },
})
</script>

<style lang="scss" scoped>
.v-list-item__icon {
  margin: 12px 0;
}
</style>
